webpackJsonp([0],{

/***/ "44eD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "698509891903f0f4b998b51088606e1c.svg";

/***/ }),

/***/ "C3I1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e4920a1e7ee1eea4c41a9ca9d596ac0.svg";

/***/ }),

/***/ "Dstl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c530e4f178e996363eb8cbe80aab64a9.svg";

/***/ }),

/***/ "Gxgu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5bec532f729ec6645852a1a4caff361a.svg";

/***/ }),

/***/ "IYUt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "90cffdacffd337dbe0a1d74938df1499.svg";

/***/ }),

/***/ "MbRD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a37e2a352c22a81739acef3fb1fbc4c9.svg";

/***/ }),

/***/ "NiQO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4dbba75fbced0ca6d9b4cdadabbc42ab.svg";

/***/ }),

/***/ "OXK2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "609c8a76c3ab9091019023d65b3a0044.svg";

/***/ }),

/***/ "b1Ns":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bdc3a064a3e5c8ba8be08e9414e60913.svg";

/***/ }),

/***/ "fMXK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2f2440e0234b7e117f350678a6540dad.svg";

/***/ }),

/***/ "gXX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_accessibility_access_svg__ = __webpack_require__("Dstl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_accessibility_access_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_accessibility_access_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_accessibility_assistiveListeningSystems_svg__ = __webpack_require__("NiQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_accessibility_assistiveListeningSystems_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_accessibility_assistiveListeningSystems_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_accessibility_audioDescription_svg__ = __webpack_require__("Gxgu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_accessibility_audioDescription_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_accessibility_audioDescription_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_accessibility_braille_svg__ = __webpack_require__("44eD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_accessibility_braille_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_accessibility_braille_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_accessibility_cc_svg__ = __webpack_require__("MbRD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_accessibility_cc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_accessibility_cc_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_accessibility_largePrint_svg__ = __webpack_require__("vFe4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_accessibility_largePrint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_accessibility_largePrint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_accessibility_oc_svg__ = __webpack_require__("OXK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_accessibility_oc_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_accessibility_oc_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_accessibility_sign_svg__ = __webpack_require__("IYUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_accessibility_sign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_accessibility_sign_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_accessibility_telephone_svg__ = __webpack_require__("fMXK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_accessibility_telephone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_accessibility_telephone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_accessibility_typewritter_svg__ = __webpack_require__("b1Ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_accessibility_typewritter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_accessibility_typewritter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_accessibility_wheelchair_svg__ = __webpack_require__("C3I1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_accessibility_wheelchair_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_accessibility_wheelchair_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ActionBar__ = __webpack_require__("4e4/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ActionButton__ = __webpack_require__("UxTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Content__ = __webpack_require__("FcPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Page__ = __webpack_require__("QYBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__state_actions_eventActions__ = __webpack_require__("Hstv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_BrowserUtils__ = __webpack_require__("WCoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_CssUtils__ = __webpack_require__("iYSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_emotion__ = __webpack_require__("mibh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Button__ = __webpack_require__("PabG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_preact_router__ = __webpack_require__("/QC5");
var _css, _css2;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var wrapper = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
  textAlign: "center",
  paddingTop: 24,
  h1: {
    fontSize: 20
  }
});

var content = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])((_css = {
  textAlign: "left",
  display: "flex",
  justifyContent: "space-between",
  padding: "40px 50px"
}, _css[Object(__WEBPACK_IMPORTED_MODULE_20__utils_CssUtils__["c" /* max */])(768)] = {
  display: "block",
  padding: "20px 14px"
}, _css));

var details = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
  maxWidth: 480,
  dt: {
    fontWeight: 600,
    fontSize: 18
  },
  dd: {
    fontSize: 14
  }
});

var featuresBox = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])({
  padding: 24,
  backgroundColor: "#fff",
  maxWidth: 360,
  width: "100%",
  border: "1px solid #dedede",
  borderRadius: 4,
  display: "block",
  height: "fit-content"
});

var navigationButtons = Object(__WEBPACK_IMPORTED_MODULE_21_emotion__["css"])((_css2 = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  button: {
    minWidth: 140
  }
}, _css2[Object(__WEBPACK_IMPORTED_MODULE_20__utils_CssUtils__["c" /* max */])(600)] = {
  justifyContent: "space-between",
  position: "fixed",
  padding: "12px 14px",
  width: "100vw",
  bottom: 0,
  left: 0,
  backgroundColor: "#fff",
  borderTop: "1px solid #dedede",
  zIndex: 9999999
}, _css2));

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  __WEBPACK_IMPORTED_MODULE_22__components_Button__["a" /* default */],
  { type: "tertiary" },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "g",
      { fill: "none", "fill-rule": "evenodd" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", {
        fill: "#788391",
        d: "M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.6-4.6z"
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M0 0h24v24H0z" })
    )
  ),
  "Back"
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "h3",
  null,
  "Features"
);

var Accessibility = function (_Component) {
  _inherits(Accessibility, _Component);

  function Accessibility(props) {
    _classCallCheck(this, Accessibility);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      back: "/" + props.eventSlug
    };
    return _this;
  }

  Accessibility.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        event = _props.event,
        getEvent = _props.getEvent,
        eventSlug = _props.eventSlug,
        matches = _props.matches;

    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    Object(__WEBPACK_IMPORTED_MODULE_19__utils_BrowserUtils__["a" /* pageChange */])("Accessibility Details", event);

    var backLocation = "/" + eventSlug;
    if (matches.source === "tickets") {
      backLocation += "/tickets";
    }
    this.setState({
      back: backLocation
    });
  };

  Accessibility.prototype.render = function render(_ref) {
    var event = _ref.event;
    var back = this.state.back;

    var features = [{
      name: "access",
      label: "Access",
      description: "This symbol indicates access for people who are blind or have low vision, best used in places such as: a guided tour, a path to a nature trail or a scent garden in a park; and a tactile tour or a museum exhibition that may be touched.",
      icon: __WEBPACK_IMPORTED_MODULE_3__assets_accessibility_access_svg___default.a
    }, {
      name: "wheelchairAccessibility",
      label: "Wheelchair Accessibility",
      description: "The wheelchair symbol indicates access for individuals with limited mobility, including wheelchair users. Remember that a ramped entrance is not completely accessible if there are no curb cuts, and an elevator is not accessible if it can only be reached via steps.",
      icon: __WEBPACK_IMPORTED_MODULE_13__assets_accessibility_wheelchair_svg___default.a
    }, {
      name: "audioDescription",
      label: "Audio Description",
      description: "The wheelchair symbol indicates access for individuals with limited mobility, including wheelchair users. Remember that a ramped entrance is not completely accessible if there are no curb cuts, and an elevator is not accessible if it can only be reached via steps.",
      icon: __WEBPACK_IMPORTED_MODULE_5__assets_accessibility_audioDescription_svg___default.a
    }, {
      name: "telephoneTypewriter",
      label: "Telephone Typewriter",
      description: "This device is also known as a text telephone (TT), or telecommunications device for the deaf (TDD). TTY indicates the presence of a device used with the telephone for communication with and between deaf, hard of hearing, speech impaired and/or hearing, persons.",
      icon: __WEBPACK_IMPORTED_MODULE_12__assets_accessibility_typewritter_svg___default.a
    }, {
      name: "volumeControlTelephone",
      label: "Volume Control Telephone",
      description: "This symbol indicates the presence of telephones that have handsets with amplified sound and/or adjustable volume controls.",
      icon: __WEBPACK_IMPORTED_MODULE_11__assets_accessibility_telephone_svg___default.a
    }, {
      name: "assistiveListeningSystems",
      label: "Assistive Listening Systems",
      description: "These systems transmit amplified sound via hearing aids, headsets of other devices",
      icon: __WEBPACK_IMPORTED_MODULE_4__assets_accessibility_assistiveListeningSystems_svg___default.a
    }, {
      name: "signLanguageInterpretation",
      label: "Sign Language Interpretation",
      description: "The symbol indicates that Sign Language Interpretation is provided for a lecture, tour, film, performance, conference or other program.",
      icon: __WEBPACK_IMPORTED_MODULE_10__assets_accessibility_sign_svg___default.a
    }, {
      name: "accessiblePrint",
      label: "Accessible Print (18 pt. or Larger)",
      description: "Large print is indicated by the words: “Large Print,” printed in 18 pt. or larger text. In addition to identifying large print versions of books, pamphlets, museum guides and theater programs, you may use the symbol on conference or membership forms with large print. Sans serif or modified serif print with high contrast is important, and special attention should be paid to letter and word spacing.",
      icon: __WEBPACK_IMPORTED_MODULE_8__assets_accessibility_largePrint_svg___default.a
    }, {
      name: "closedCaptioning",
      label: "Closed Captioning (CC)",
      description: "Closed Captioning (CC) (commonly known as subtitles) enables people who are deaf or hard of hearing to read a transcript of the audio portion of a video, film, exhibition or other presentation. As the video plays, text captions transcribe (although not always verbatim) speech and other relevant sounds.",
      icon: __WEBPACK_IMPORTED_MODULE_7__assets_accessibility_cc_svg___default.a
    }, {
      name: "openedCaptioning",
      label: "Opened Captioning (OC)",
      description: "This symbol indicates that captions, which translate dialogue and other sounds in print, are displayed on the videotape, movie, television program or exhibit audio. Open Captioning is preferred by many, including deaf and hard-of-hearing individuals, and people whose second language is English. It also helps teach children how to read and keep sound levels to a minimum in museums and restaurants.",
      icon: __WEBPACK_IMPORTED_MODULE_9__assets_accessibility_oc_svg___default.a
    }, {
      name: "brailleSymbol",
      label: "Braille Symbol",
      description: "This symbol indicates that printed material is available in Braille, including exhibition labeling, publications and signage.",
      icon: __WEBPACK_IMPORTED_MODULE_6__assets_accessibility_braille_svg___default.a
    }];
    if (!event.data) {
      return;
    }
    var accessibility = event.data.accessibility;
    var detailsList = [];

    if (accessibility.contactName) {
      detailsList.push({
        label: "Contact Name",
        value: accessibility.contactName
      });
    }
    if (accessibility.contactNumber) {
      detailsList.push({
        label: "Contact Number",
        value: accessibility.contactNumber
      });
    }

    if (accessibility.travelInstructions) {
      detailsList.push({
        label: "Travel Instructions",
        value: accessibility.travelInstructions
      });
    }

    if (accessibility.entryInstructions) {
      detailsList.push({
        label: "Entry Instructions",
        value: accessibility.entryInstructions
      });
    }

    if (accessibility.afterEntryInstructions) {
      detailsList.push({
        label: "After Entry Instructions",
        value: accessibility.afterEntryInstructions
      });
    }

    if (accessibility.hazards) {
      detailsList.push({
        label: "Hazards",
        value: accessibility.hazards
      });
    }

    if (accessibility.toiletLocation) {
      detailsList.push({
        label: "Toilet Location",
        value: accessibility.toiletLocation
      });
    }

    if (accessibility.disabledParking) {
      detailsList.push({
        label: "Accessible Parking",
        value: accessibility.disabledParking
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      __WEBPACK_IMPORTED_MODULE_17__components_Page__["a" /* default */],
      { background: false },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_16__components_Content__["a" /* default */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "div",
          { className: wrapper },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "h1",
            null,
            event.data.name + " Accessibility Details"
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { className: content },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { className: details },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                "dl",
                null,
                detailsList.map(function (detail) {
                  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    "div",
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                      "dt",
                      null,
                      detail.label
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                      "dd",
                      null,
                      detail.value
                    )
                  );
                })
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                "div",
                { "class": navigationButtons },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
                  { href: back },
                  _ref2
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
                  { href: "/" + event.data.slug + "/tickets" },
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_15__components_ActionButton__["a" /* default */],
                    { style: { marginLeft: 12 } },
                    "Get Tickets"
                  )
                )
              )
            ),
            accessibility.features ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "div",
              { className: featuresBox },
              _ref3,
              features.map(function (feature) {
                var styles = {
                  background: "url(" + feature.icon + ") left top no-repeat",
                  backgroundSize: 50,
                  padding: "0 0 0 60px",
                  margin: "0 0 10px 0",
                  minHeight: 50
                };
                return accessibility.features && accessibility.features[feature.name] ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  "h4",
                  { style: styles },
                  feature.label
                ) : null;
              })
            ) : null
          )
        )
      )
    );
  };

  return Accessibility;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
  return { event: state.event };
}, {
  getEvent: __WEBPACK_IMPORTED_MODULE_18__state_actions_eventActions__["u" /* getEvent */]
})(Accessibility));

/***/ }),

/***/ "vFe4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a94ec432242e443143e010c0342ded56.svg";

/***/ })

});


// WEBPACK FOOTER //
// 0.chunk.8557e.js